import './styles/Notificacao.css';

import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import NotificacaoItemList from './NotificacaoItemList';
import NotificacaoVazio from './NotificacaoVazio';
import { getNotificacoes, marcarTodasComoLidas } from '../../../actions';

const configureListeners = () => {
  const dropdown = document.getElementById('dropdownMenu');
  const notificacaoComponent = document.getElementById('dropdown-notificacao');

  if (!dropdown || !notificacaoComponent) {
    return () => {};
  }

  const handleDropdownClick = () => {
    if (notificacaoComponent.className.includes('show')) {
      notificacaoComponent.classList.remove('show');
      return;
    }

    notificacaoComponent.classList.add('show');
  };

  const handleWindowClick = event => {
    const { parentNode, className } = event.target;

    if (
      parentNode &&
      parentNode.id !== dropdown.id &&
      typeof className === 'string' &&
      !className.includes('dot') &&
      !className.includes('loadmore')
    ) {
      notificacaoComponent.classList.remove('show');
    }
  };

  dropdown.addEventListener('click', handleDropdownClick);
  window.addEventListener('click', handleWindowClick);

  return () => {
    dropdown.removeEventListener('click', handleDropdownClick);
    window.removeEventListener('click', handleWindowClick);
  };
};

const Notificacao = ({ notificacoes, notificacoesNaoLidas, getAction, totalNotificacoes }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();

  useEffect(() => {
    getAction(currentPage);
  }, [getAction, currentPage]);

  useEffect(() => {
    const removeListeners = configureListeners();

    return function cleanup() {
      removeListeners();
    };
  }, []);

  function marcarTodasLidas() {
    dispatch(marcarTodasComoLidas());
  }

  const hideLoadMore = currentPage * 5 >= totalNotificacoes;

  return (
    <div className="notificacao-icon-container">
      <div className="dropdown c-pointer">
        <div
          className="dropdown-toggle"
          id="dropdownMenu"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <i className="fa fa-bell grey notificacao-badge" data-badge={notificacoesNaoLidas} />
        </div>
        <ul
          id="dropdown-notificacao"
          className="dropdown-menu mt-1 w-400 fix-h-337 xs-scroll"
          aria-labelledby="dropdownMenu"
        >
          <li className="dropdown-header mb-2">
            <span className="flex-row">
              Notificações
              {notificacoesNaoLidas > 1 && (
                <button
                  type="button"
                  onClick={marcarTodasLidas}
                  className="badge btn btn-link float-right"
                >
                  <small>Marcar todas como lidas</small>
                </button>
              )}
            </span>
          </li>
          {notificacoes.length ? (
            <NotificacaoItemList dataSource={notificacoes} />
          ) : (
            <NotificacaoVazio />
          )}

          {!hideLoadMore && (
            <li>
              <button
                type="button"
                className="btn btn-link btn-block loadmore"
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Ver mais
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  notificacoes: state.notificacao.notificacoes,
  totalNotificacoes: state.notificacao.totalNotificacoes,
  notificacoesNaoLidas: state.notificacao.notificacoesNaoLidas,
});

export default connect(
  mapStateToProps,
  { getAction: getNotificacoes },
)(Notificacao);
